// JavaScript code for acf_blocks/booking-programme-listing component
(() => {
    "use strict";

    document.querySelectorAll('[data-booking-listing]').forEach((listing) => {
        const form = listing.querySelector('[data-booking-listing-filters]');
        if (!form) return;

        const yearSelect    = form.querySelector('[data-booking-listing-year]');
        const subjectSelect = form.querySelector('[data-booking-listing-subject]');
        const viewInput     = form.querySelector('[data-booking-listing-view-input]');

        // The filters are a plain GET form (works without JS) - this only submits it as soon as a
        // value changes. A new year clears the subject: each year has its own subject list, so the
        // old choice may not exist for it.
        if (yearSelect) {
            yearSelect.addEventListener('change', () => {
                if (subjectSelect) subjectSelect.value = '';
                form.submit();
            });
        }

        if (subjectSelect) {
            subjectSelect.addEventListener('change', () => form.submit());
        }

        // Grid/list switch: the cards read the view from one ancestor `data-view` attribute (see
        // the programme-card component), so switching in place never re-renders anything. The
        // address bar and the filter form keep the choice, so a refresh or the next filter change
        // stays in the same view.
        listing.querySelectorAll('[data-booking-listing-view]').forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();

                const view    = toggle.dataset.bookingListingView;
                const results = listing.querySelector('[data-booking-listing-results]');

                if (results) results.dataset.view = view;
                if (viewInput) viewInput.value = view;

                listing.querySelectorAll('[data-booking-listing-view]').forEach((other) => {
                    other.setAttribute('aria-pressed', other === toggle ? 'true' : 'false');
                });

                const url = new URL(window.location.href);
                if (view === 'list') {
                    url.searchParams.set('view', 'list');
                } else {
                    url.searchParams.delete('view');
                }
                history.replaceState(null, '', url);
            });

            // role="button" on a link: Space should activate it like a real button.
            toggle.addEventListener('keydown', (e) => {
                if (e.key === ' ') {
                    e.preventDefault();
                    toggle.click();
                }
            });
        });
    });
})();
